module.exports = __webpack_public_path__ + "img/symbol_1.387081b6.png";